<template lang="pug">
    include DiscountType.pug
</template>

<script>
import S from "string"
import _ from "underscore"

export default {
  name: 'DiscountType',
  props: [
    "slug",
  ],
  data () {
    return {
      discount: null,
    }
  },
  created() {
    const _this = this
    let slug = this.slug

    _this.$wagtail.getDiscounts(1, {slug}).then(response => {
      let data = response.data
      _this.discount = _.first(data.results)
    }).catch(err => {
    })
  },
  filters: {
    cleanweb: function(value) {
      return S(value)
        .chompLeft("https://")
        .chompLeft("http://")
        .s
    }
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";

@import "Discounts";

</style>



// WEBPACK FOOTER //
// src/components/discounts/DiscountType.vue